import {Component, OnInit, Type} from '@angular/core';
import {AbstractApplicationFlowComponent} from '../../application-flow/abstract-application-flow.component';
import {Step} from '../../application-flow/steps/step';
import {BorrowerSummaryStep} from '../../application-flow/steps/borrower-summary.step';
import {LoanApplicationFlowNavigator} from '../../application-flow/loan-application-flow.navigator';
import {ActivatedRoute, Router} from '@angular/router';
import {LoanApplicationService} from '../../service/loan-application.service';
import {Toaster} from '../../toaster/Toaster';
import {Summary} from '../../model/summary.model';
import {LoanApplicationPipelineStage, LoanApplicationTransition} from '../../model/LoanApplicationTransition';

@Component({
    selector: 'app-borrower-summary',
    templateUrl: './borrower-summary.component.html',
    styleUrls: ['./borrower-summary.component.css']
})
export class BorrowerSummaryComponent extends AbstractApplicationFlowComponent implements OnInit {
    public summary: Summary;
    shouldShowLoader: boolean;

    constructor(navigator: LoanApplicationFlowNavigator, private activatedRoute: ActivatedRoute,
                private loanApplicationService: LoanApplicationService, private router: Router) {
        super(navigator);
    }

    ngOnInit(): void {
        this.activatedRoute.data.subscribe((data) => {
            this.summary = data.summary;
        });
    }

    step(): Type<Step> {
        return BorrowerSummaryStep;
    }

    async submitApplication(): Promise<void> {
        try {
            this.shouldShowLoader = true;
            const loanApplicationId = this.summary.getLoanApplicationId();
            const applicationTransition = new LoanApplicationTransition(LoanApplicationPipelineStage.Verification);
            await this.loanApplicationService.transitApplication(loanApplicationId, applicationTransition);
            await this.router.navigate([`borrow/application/${loanApplicationId}/status`]);
            this.shouldShowLoader = false;
        } catch (error) {
            this.shouldShowLoader = false;
            Toaster.toast('Something went wrong while submitting the application. Please try again.');
        }
    }
}
